import React, { useState, useEffect } from "react";
import { CustomCard, CustomCardContent, CustomCardHeaderWithPopover,Divider } from './CustomComponents';
import Plot from 'react-plotly.js';
import { useGraphContext } from '../GraphContext';
import Spinner from "./Spinner";
import intraday_shift from '../assets/intraday_shifts.png';

const Intraday_Mileage = ({ submitClicked, handleDownload, error}) => {
  const [histogramData_mileage, setHistogramData_mileage] = useState(null);
  const [boxPlotData_mileage, setBoxPlotData_mileage] = useState(null);

  const [histogramData_duration, setHistogramData_duration] = useState(null);
  const [boxPlotData_duration, setBoxPlotData_duration] = useState(null);

  const [histogramData_speed, setHistogramData_speed] = useState(null);
  const [boxPlotData_speed, setBoxPlotData_speed] = useState(null);
  
  const [histogramData_count, setHistogramData_count] = useState(null);
  const [boxPlotData_count, setBoxPlotData_count] = useState(null);

  const [histogramData_breaktime, setHistogramData_breaktime] = useState(null);
  const [boxPlotData_breaktime, setBoxPlotData_breaktime] = useState(null);

  const [loading, setLoading] = useState(true); // Loading state

  // Define a style object for bold text
  const boldStyle = {
    fontWeight: 'bold'
  };

  const { filters } = useGraphContext();
  useEffect(() => {
      if (filters) {
          try {
              const intraday_milage = JSON.parse(filters.intraday_milage_bin);
              const intraday_duration=JSON.parse(filters.intraday_duration_bin);
              const intraday_count=JSON.parse(filters.intraday_shift_cnt_bin);
              const intraday_avg_speed_bin=JSON.parse(filters.intraday_avg_speed_bin);
              const intraday_breaktime_before_shift=JSON.parse(filters.intraday_breaktime_before_shift);

              const intraday_milage_box = filters.box.shift_mileage__km_p95_30min;              
              const intraday_duration_box=filters.box.shift_duration__hour_p95_30min;              
              const intraday_count_box=filters.box.cnt_of_shifts_year_30min;
              const intraday_avg_speed_bin_box=filters.box.avg_speed_year_30min;
              const breaktime_before_shift__hour_p10_30min=filters.box.breaktime_before_shift__hour_p10_30min;

              console.log(intraday_breaktime_before_shift)

              setHistogramData_mileage(intraday_milage);
              setHistogramData_duration(intraday_duration);
              setHistogramData_count(intraday_count);
              setHistogramData_speed(intraday_avg_speed_bin);
              setHistogramData_breaktime(intraday_breaktime_before_shift);
        

              setBoxPlotData_mileage(intraday_milage_box);
              setBoxPlotData_duration(intraday_duration_box);
              setBoxPlotData_speed(intraday_avg_speed_bin_box);
              setBoxPlotData_count(intraday_count_box);
              setBoxPlotData_breaktime(breaktime_before_shift__hour_p10_30min);

          } catch (error) {
              console.error('Error parsing JSON:', error);
          } finally {
            setLoading(false); // Set loading to false after data processing
        }
      }
      else{
        setLoading(false); // Set loading to false after data processing 
    }
  }, [filters]);

  return (
    <div className="KPI_main_div" >
    <div>
        <div className="outer_div_title_onTop_of_KPI" >
            <h6 className="title_onTop_of_KPI" >Definition</h6>
        </div>

        <div style={{ display: 'flex', backgroundColor: 'white',alignItems: 'center', padding: '10px'}}>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={intraday_shift} style={{ width: '100%', margin: 0, padding: 0}}/>
            </div>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                <ul style={{ fontFamily: 'MAN EUROPE_regular', fontSize: '16px', color: 'rgb(48, 60, 73)' }}>
                    <li>A shift is a vehicle operation between two breaks of a defined period of time.</li>
                    <li>
                    On this page we investigate shifts <span style={{ fontWeight: 'bold' }}>between a break time of at least 30 minutes.</span>
                    </li>
                    <li>Generally speaking this represents all individual single rides of a vehicle.</li>
                    <li>
                    We are <span style={{ fontStyle: 'italic' }}>not</span> providing statistics on shifts in between a break time of 
                    <span style={{ fontStyle: 'italic' }}> less </span> than 30 minutes, because
                    <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                        <li>we aim to visualize shifts that are representative of the vehicles' transport tasks</li>
                        <li>the number of non-representative shifts increases significantly with shorter break times</li>
                    </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
 
    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Shift mileage (95th percentile)</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Intraday_Mileage_histo'
                    content= {
                        `<ul>
                        <li>This histogram visualizes the distribution of numerical data using bins of 50 km each. Each bar represents the absolute count of VINs (vehicles) falling within a specific mileage range, based on your selection on the "Filter" page.</li>
                        
                        <li><b>Metric:</b> This chart displays the 95th percentile of shift mileage per vehicle and year. The 95th percentile represents a value of mileage where 95 percent of all shifts per vehicle and year are smaller than this value. Meaning that only 5 percent of shifts for that vehicle and year had higher mileage. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
                        
                        <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
                        Example: A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
                        As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                        
                        <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across mileage bins.</li>
                        </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="intraday_milage_bin"
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_mileage ? (
                                    <Plot
                                        data={histogramData_mileage.data}
                                        layout={histogramData_mileage.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Intraday_Mileage_box'
                    content= {
                    `<ul>
                    <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                    
                    <li><b>Metric:</b> This chart focuses on the 95th percentile of shift duration per vehicle and year. The 95th percentile represents a value of duration where 95 percent of all shifts per vehicle and year are smaller than this value, meaning only 5 percent of shifts for that vehicle and year had higher duration. This highlights typical high-usage behavior while minimizing the impact of outliers.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                    
                    <li><b>Visualization:</b> The boxplot shows the distribution of the 95th percentile of shift duration using five key values:
                        <ul>
                        <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                        <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                        <li><b>50th percentile (Median)</b> – the middle value</li>
                        <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                        <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                        </ul>
                    </li>
                    
                    <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                    </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="shift_mileage__km_p95_30min" 
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_mileage ? (
                                    <Plot
                                        data={boxPlotData_mileage.data}
                                        layout={boxPlotData_mileage.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Shift duration (95th percentile)</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Intraday_duration_histo'
                    content= {
                        `<ul>
                        <li>This histogram visualizes the distribution of numerical data using bins of 1 h each. Each bar represents the absolute count of VINs (vehicles) falling within a specific duration range, based on your selection on the "Filter" page.</li>
                        
                        <li><b>Metric:</b> This chart displays the 95th percentile of shift duration per vehicle and year. The 95th percentile represents a value of duration where 95 percent of all shifts per vehicle and year are smaller than this value. Meaning that only 5 percent of shifts for that vehicle and year had higher duration. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
                        
                        <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
                        Example: A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
                        As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                        
                        <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across duration bins.</li>
                        </ul>`

                    }
                    handleDownload={handleDownload}
                    downloadOption="intraday_duration_bin" 
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_duration ? (
                                    <Plot
                                        data={histogramData_duration.data}
                                        layout={histogramData_duration.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Intraday_duration_box'
                    content= {
                `<ul>
                <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                
                <li><b>Metric:</b> This chart focuses on the 95th percentile of shift duration per vehicle and year. The 95th percentile represents a value of duration where 95 percent of all shifts per vehicle and year are smaller than this value, meaning only 5 percent of shifts for that vehicle and year had higher duration. This highlights typical high-usage behavior while minimizing the impact of outliers.</li>
                
                <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                
                <li><b>Visualization:</b> The boxplot shows the distribution of the 95th percentile of shift duration using five key values:
                    <ul>
                    <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                    <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                    <li><b>50th percentile (Median)</b> – the middle value</li>
                    <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                    <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                    </ul>
                </li>
                
                <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="shift_duration__hour_p95_30min" 
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_duration ? (
                                    <Plot
                                        data={boxPlotData_duration.data}
                                        layout={boxPlotData_duration.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Shift average speed</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Intraday_speed_histo'
                    content= {
                        `<ul>
                        <li>This histogram visualizes the distribution of numerical data using bins of 10 km/h each. Each bar represents the absolute count of VINs (vehicles) falling within a specific speed range, based on your selection on the "Filter" page.</li>
                        
                        <li><b>Metric:</b> This chart displays the shift average speed per vehicle and year.</li>
                        
                        <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
                        Example: A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
                        As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                        
                        <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across speed bins.</li>
                        </ul>`
                    } 
                    handleDownload={handleDownload}
                    downloadOption="intraday_avg_speed_bin"
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_speed ? (
                                    <Plot
                                        data={histogramData_speed.data}
                                        layout={histogramData_speed.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Intraday_speed_box'
                    content= {
                    `<ul>
                    <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                    
                    <li><b>Metric:</b> This chart focuses on the absolute count of shifts per vehicle and year.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                    
                    <li><b>Visualization:</b> The boxplot shows the distribution of the count of shifts using five key values:
                        <ul>
                        <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                        <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                        <li><b>50th percentile (Median)</b> – the middle value</li>
                        <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                        <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                        </ul>
                    </li>
                    
                    <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                    </ul>`

                    }
                    handleDownload={handleDownload}
                    downloadOption="avg_speed_year_30min"  
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_speed ? (
                                    <Plot
                                        data={boxPlotData_speed.data}
                                        layout={boxPlotData_speed.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                        )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Count of shifts</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Intraday_count_histo'
                    content= {
                    `<ul>
                    <li>This histogram visualizes the distribution of numerical data using bins of 50 each. Each bar represents the absolute count of VINs (vehicles) falling within a specific count range, based on your selection on the "Filter" page.</li>
                    
                    <li><b>Metric:</b> This chart displays the absolute count of shifts per vehicle and year.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
                    Example: A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
                    As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                    
                    <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across count bins.</li>
                    </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="intraday_shift_cnt_bin"
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_count ? (
                                    <Plot
                                        data={histogramData_count.data}
                                        layout={histogramData_count.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Intraday_count_box'
                    content= {
                `<ul>
                <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                
                <li><b>Metric:</b> This chart focuses on the absolute count of shifts per vehicle and year.</li>
                
                <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                
                <li><b>Visualization:</b> The boxplot shows the distribution of the count of shifts using five key values:
                    <ul>
                    <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                    <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                    <li><b>50th percentile (Median)</b> – the middle value</li>
                    <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                    <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                    </ul>
                </li>
                
                <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="cnt_of_shifts_year_30min" 
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_count ? (
                                    <Plot
                                        data={boxPlotData_count.data}
                                        layout={boxPlotData_count.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>

    <div style={{ marginTop: '20px'}}>
      <div className="outer_div_title_onTop_of_KPI" >
        <h6 className="title_onTop_of_KPI" >Break time before shift start (10th percentile)</h6>
      </div>

        <div className="plot_div" >
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Intraday_breaktime_histo'
                    content= {
                    `<ul>
                    <li>This histogram visualizes the distribution of numerical data using bins of 0,25 h each. Each bar represents the absolute count of VINs (vehicles) falling within a specific break time range, based on your selection on the "Filter" page.</li>
                    
                    <li><b>Metric:</b> This chart displays the 10th percentile of shift break time per vehicle and year. The 10th percentile represents a value of break time where 10 percent of all breaks per vehicle and year are shorter than this value. Meaning that 90 percent of the breaks for that vehicle and year were longer. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br />
                    Example: A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.<br />
                    As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                    
                    <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across break time bins.</li>
                    </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="intraday_breaktime_before_shift"
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_breaktime ? (
                                    <Plot
                                        data={histogramData_breaktime.data}
                                        layout={histogramData_breaktime.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Intraday_breaktime_box'
                    content= {
                        `<ul>
                        <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                        
                        <li><b>Metric:</b> This chart focuses on the 10th percentile of shift break time per vehicle and year. The 10th percentile represents a value of break time where 10 percent of all breaks per vehicle and year are shorter than this value. Meaning that 90 percent of the breaks for that vehicle and year were longer. This helps focus on typical high-usage behavior while minimizing the impact of outliers.</li>
                        
                        <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                        
                        <li><b>Visualization:</b> The boxplot shows the distribution of the 10th percentile of shift break time using five key values:
                            <ul>
                            <li><b>5th percentile (Min)</b> – the lower extreme of the data</li>
                            <li><b>25th percentile (Q1)</b> – the lower quartile</li>
                            <li><b>50th percentile (Median)</b> – the middle value</li>
                            <li><b>75th percentile (Q3)</b> – the upper quartile</li>
                            <li><b>95th percentile (Max)</b> – the upper extreme of the data</li>
                            </ul>
                        </li>
                        
                        <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                        </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="breaktime_before_shift__hour_p10_30min" 
                />
                <Divider className="divider" /> 
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData_breaktime ? (
                                    <Plot
                                        data={boxPlotData_breaktime.data}
                                        layout={boxPlotData_breaktime.layout}
                                        config={{ responsive: true }}
                                        style={{ width: '100%', height: '100%' }}
                                        useResizeHandler={true}
                                        autosize={true}
                                        />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
        </div>
    </div>
    </div>
  );
};

export default Intraday_Mileage;
